module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ourFoodTrucks":"Unsere Foodtrucks","new":"Neu","export":"Exportieren","active":"Aktive Foodtrucks","inactive":"Inaktive Foodtrucks"},"en":{"ourFoodTrucks":"Our food trucks","new":"New","export":"Export","active":"Active food trucks","inactive":"Inactive food trucks"}}')
  delete Component.options._Ctor
}
